import {createAction, props} from '@ngrx/store';
import {User} from '@capacitor-firebase/authentication';

export const userLoad = createAction('[App] User Load', props<{ user: User }>());
export const authenticated = createAction('[App] Authenticated');
export const unauthenticated = createAction('[App] Unauthenticated');
export const websocketActivated = createAction('[App] Websocket Activated');
export const websocketOpened = createAction('[App] Websocket Opened');
export const websocketClosed = createAction('[App] Websocket Closed');
export const reconnect = createAction('[App] Reconnect');
export const notificationToken = createAction('[App] Notification Token', props<{ token: string }>());
export const screenResized = createAction('[App] Screen Resize');
